// ==================== DASHBOARD ====================
import { useEffect, useState } from 'react';
import { getFaturamento, getProdutosMaisVendidos } from '../../services/api';

export function AdminDashboard() {
  const [dados, setDados] = useState(null);
  const [top, setTop] = useState([]);

  useEffect(() => {
    getFaturamento('diario').then(r => setDados(r.data)).catch(() => {});
    getProdutosMaisVendidos().then(r => setTop(r.data)).catch(() => {});
  }, []);

  const resumo = dados?.resumo || {};

  return (
    <div style={{ padding: 16 }}>
      <h2>📊 Dashboard</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
        {[
          ['Faturamento hoje', `R$ ${parseFloat(resumo.faturamento_total||0).toFixed(2).replace('.',',')}`, 'var(--red)'],
          ['Pedidos hoje', resumo.total_pedidos || 0, 'var(--orange)'],
          ['Ticket médio', `R$ ${parseFloat(resumo.ticket_medio||0).toFixed(2).replace('.',',')}`, '#2ea82e'],
          ['Clientes ativos', resumo.clientes_ativos || 0, '#4a9eff'],
        ].map(([label, val, cor]) => (
          <div key={label} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 14, textAlign: 'center' }}>
            <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 28, color: cor, lineHeight: 1 }}>{val}</div>
            <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      <h3 style={{ marginBottom: 10 }}>🔥 Mais vendidos</h3>
      {top.slice(0, 5).map((p, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 10, background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 8, marginBottom: 6 }}>
          <span style={{ fontSize: 22 }}>{p.emoji}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700 }}>{p.nome}</div>
            <div style={{ fontSize: 11, color: 'var(--text2)' }}>{p.qtd_vendida} vendidos</div>
          </div>
          <div style={{ color: 'var(--orange)', fontWeight: 800, fontSize: 13 }}>R$ {parseFloat(p.receita||0).toFixed(2).replace('.',',')}</div>
        </div>
      ))}
    </div>
  );
}

// ==================== PEDIDOS ADMIN ====================
import { getPedidosAdmin, atualizarStatus } from '../../services/api';

export function AdminPedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);

  const carregar = () => getPedidosAdmin().then(r => setPedidos(r.data)).finally(() => setLoading(false));
  useEffect(() => { carregar(); const i = setInterval(carregar, 30000); return () => clearInterval(i); }, []);

  const mudarStatus = async (id, status) => {
    await atualizarStatus(id, status);
    carregar();
  };

  const STATUS_NEXT = { aguardando: [['aceito','Aceitar','var(--orange)']], aceito: [['preparo','Iniciar preparo','var(--red)']], preparo: [['pronto','Marcar pronto','#2ea82e']], pronto: [['entregando','Saiu para entrega','#4a9eff']], entregando: [['entregue','Entregue','#2ea82e']] };

  if (loading) return <div style={{ padding: 16 }}><div className="spinner" /></div>;

  return (
    <div style={{ padding: 16 }}>
      <h2>📦 Pedidos</h2>
      {!pedidos.length ? <div className="empty-state"><div className="icon">📦</div><p>Nenhum pedido</p></div> : pedidos.map(p => (
        <div key={p.id} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 14, marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <div><div style={{ fontWeight: 700 }}>#{p.id} — {p.cliente_nome}</div><div style={{ fontSize: 11, color: 'var(--text2)' }}>{p.cliente_tel}</div></div>
            <div style={{ fontWeight: 800, color: 'var(--orange)' }}>R$ {parseFloat(p.total).toFixed(2).replace('.',',')}</div>
          </div>
          <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>{p.itens_resumo}</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {(STATUS_NEXT[p.status] || []).map(([s, label, cor]) => (
              <button key={s} onClick={() => mudarStatus(p.id, s)} style={{ background: `${cor}22`, border: `1px solid ${cor}`, color: cor, padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>{label}</button>
            ))}
            {p.status !== 'cancelado' && p.status !== 'entregue' && (
              <button onClick={() => mudarStatus(p.id, 'cancelado')} style={{ background: 'rgba(230,48,48,.1)', border: '1px solid var(--red)', color: 'var(--red)', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>Cancelar</button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

// ==================== CLIENTES ====================
import { getClientesRanking } from '../../services/api';

export function AdminClientes() {
  const [clientes, setClientes] = useState([]);
  useEffect(() => { getClientesRanking().then(r => setClientes(r.data)).catch(() => {}); }, []);

  return (
    <div style={{ padding: 16 }}>
      <h2>👥 Ranking de Clientes</h2>
      {clientes.map((c, i) => (
        <div key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, marginBottom: 6 }}>
          <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 20, width: 28, textAlign: 'center', color: i === 0 ? 'gold' : i === 1 ? 'silver' : i === 2 ? '#cd7f32' : 'var(--text3)' }}>{i + 1}</div>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,var(--red),var(--orange))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 14, color: '#fff', flexShrink: 0 }}>{c.nome[0]}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 700 }}>{c.nome}</div>
            <div style={{ fontSize: 11, color: 'var(--orange)' }}>⭐ {c.pontos} pontos • {c.qtd_pedidos} pedidos</div>
          </div>
          <div style={{ fontSize: 12, color: 'var(--text2)', textAlign: 'right' }}>R$ {parseFloat(c.total_gasto||0).toFixed(2).replace('.',',')}</div>
        </div>
      ))}
    </div>
  );
}

// ==================== ROLETA ADMIN ====================
import { getRoletaConfig, salvarRoletaConfig, atualizarPremio } from '../../services/api';

export function AdminRoleta() {
  const [config, setConfig] = useState({ ativo: 1, titulo: '', subtitulo: '' });
  const [premios, setPremios] = useState([]);
  const [toast, setToast] = useState('');
  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  useEffect(() => {
    getRoletaConfig().then(r => { setConfig(r.data.config || {}); setPremios(r.data.premios || []); }).catch(() => {});
  }, []);

  const salvarConfig = async () => {
    await salvarRoletaConfig(config);
    showToast('✅ Configuração salva!');
  };

  const salvarPremio = async (p) => {
    await atualizarPremio(p.id, p);
    showToast('✅ Prêmio atualizado!');
  };

  return (
    <div style={{ padding: 16 }}>
      {toast && <div style={{ position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999 }}>{toast}</div>}
      <h2>🎰 Controle da Roleta</h2>

      <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 14, marginBottom: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div><div style={{ fontWeight: 700 }}>Roleta ativa</div><div style={{ fontSize: 12, color: 'var(--text2)' }}>Mostrar após pagamento</div></div>
          <label style={{ position: 'relative', width: 52, height: 28, cursor: 'pointer' }}>
            <input type="checkbox" checked={config.ativo == 1} onChange={e => setConfig(p => ({ ...p, ativo: e.target.checked ? 1 : 0 }))} style={{ opacity: 0, width: 0, height: 0 }} />
            <span style={{ position: 'absolute', inset: 0, background: config.ativo == 1 ? 'var(--orange)' : 'var(--bg4)', border: `1px solid ${config.ativo == 1 ? 'var(--orange)' : 'var(--border)'}`, borderRadius: 14, transition: '.2s' }}>
              <span style={{ position: 'absolute', width: 22, height: 22, background: '#fff', borderRadius: '50%', top: 2, left: config.ativo == 1 ? 26 : 2, transition: '.2s' }} />
            </span>
          </label>
        </div>
        <button className="btn-primary" onClick={salvarConfig}>💾 Salvar configuração</button>
      </div>

      <h3 style={{ marginBottom: 10 }}>Prêmios</h3>
      {premios.map(p => (
        <div key={p.id} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 12, marginBottom: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <div style={{ width: 14, height: 14, borderRadius: '50%', background: p.cor }} />
            <span style={{ fontWeight: 700, flex: 1 }}>{p.nome}</span>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer' }}>
              <input type="checkbox" checked={p.ativo == 1} onChange={e => setPremios(prev => prev.map(x => x.id === p.id ? { ...x, ativo: e.target.checked ? 1 : 0 } : x))} />
              Ativo
            </label>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
            <span style={{ color: 'var(--text2)' }}>Probabilidade:</span>
            <input type="range" min="1" max="50" value={p.probabilidade} onChange={e => setPremios(prev => prev.map(x => x.id === p.id ? { ...x, probabilidade: e.target.value } : x))} style={{ flex: 1 }} />
            <span style={{ color: 'var(--orange)', fontWeight: 700, minWidth: 36 }}>{p.probabilidade}%</span>
          </div>
          <button onClick={() => salvarPremio(p)} style={{ marginTop: 8, background: 'none', border: '1px solid var(--border)', color: 'var(--text2)', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontFamily: 'Nunito,sans-serif' }}>Salvar</button>
        </div>
      ))}
    </div>
  );
}

// ==================== RELATÓRIOS ====================
export function AdminRelatorios() {
  const [periodo, setPeriodo] = useState('diario');
  const [dados, setDados] = useState(null);

  useEffect(() => {
    getFaturamento(periodo).then(r => setDados(r.data)).catch(() => {});
  }, [periodo]);

  const resumo = dados?.resumo || {};
  const porDia = dados?.por_dia || [];
  const maxFat = Math.max(...porDia.map(d => parseFloat(d.faturamento || 0)), 1);

  return (
    <div style={{ padding: 16 }}>
      <h2>📈 Relatórios</h2>
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['diario','Hoje'],['semanal','Semanal'],['quinzenal','Quinzenal'],['mensal','Mensal']].map(([key, label]) => (
          <button key={key} onClick={() => setPeriodo(key)} style={{
            background: periodo === key ? 'linear-gradient(90deg,var(--red),var(--orange))' : 'var(--bg4)',
            border: `1px solid ${periodo === key ? 'transparent' : 'var(--border)'}`,
            color: periodo === key ? '#fff' : 'var(--text2)',
            padding: '7px 14px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontFamily: 'Nunito,sans-serif', fontWeight: 700
          }}>{label}</button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
        {[
          ['Faturamento', `R$ ${parseFloat(resumo.faturamento_total||0).toFixed(2).replace('.',',')}`, 'var(--red)'],
          ['Pedidos', resumo.total_pedidos || 0, 'var(--orange)'],
          ['Ticket médio', `R$ ${parseFloat(resumo.ticket_medio||0).toFixed(2).replace('.',',')}`, '#2ea82e'],
          ['Clientes', resumo.clientes_ativos || 0, '#4a9eff'],
        ].map(([label, val, cor]) => (
          <div key={label} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 14, textAlign: 'center' }}>
            <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 26, color: cor, lineHeight: 1 }}>{val}</div>
            <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {porDia.length > 0 && (
        <>
          <h3 style={{ marginBottom: 10 }}>Faturamento por dia</h3>
          {porDia.map((d, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <div style={{ fontSize: 11, color: 'var(--text2)', width: 80, flexShrink: 0 }}>{new Date(d.data).toLocaleDateString('pt-BR')}</div>
              <div style={{ flex: 1, height: 24, background: 'var(--bg4)', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${(parseFloat(d.faturamento||0)/maxFat)*100}%`, background: 'linear-gradient(90deg,var(--red),var(--orange))', borderRadius: 4, display: 'flex', alignItems: 'center', paddingLeft: 8, fontSize: 11, fontWeight: 700, color: '#fff', minWidth: 60 }}>
                  R$ {parseFloat(d.faturamento||0).toFixed(0)}
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
